const en = {
    mainText: `GOODS Israel is a personal marketplace created for convenient, safe, and simple posting of items for sale.
  The project was created to make the buying and selling process as comfortable as possible for both individuals and small sellers in Israel.`,
    
    ourGoalTitle: "Our Goal",
    ourGoalText: "We aim to create a space where every user can easily:",
    goalList: [
      "Post an item for sale",
      "Find the right item at a fair price",
      "Quickly contact the seller or buyer",
      "Use the platform without unnecessary steps or complications"
    ],
  
    whyGoodsTitle: "Why GOODS?",
    cards: [
      {
        subtitle: "Convenience",
        text: "Intuitive interface, simple item posting form, and well-structured catalog."
      },
      {
        subtitle: "Personal Approach",
        text: "GOODS Israel is a convenient platform for you. We make a marketplace where each user can easily manage their listings, profile, and communication."
      },
      {
        subtitle: "Safety and Transparency",
        text: "We carefully protect data. All personal information is processed according to Israeli law, and servers are located in Frankfurt, ensuring stability and high security."
      },
      {
        subtitle: "Fast Moderation",
        text: "We ensure that only honest offers are posted. Listings go through quick review and moderation."
      }
    ],
  
    forWhomTitle: "Who is this project for?",
    forWhomText: "GOODS is suitable for anyone who wants to:",
    forWhomList: [
      "Sell personal items",
      "Buy something at a good price",
      "Post products from their small business",
      "Run sales without complex setup or technical knowledge"
    ],
  
    contactTitle: "Contact",
    contactText: "If you have any questions or suggestions - we are always open to feedback. We strive to develop the platform and make it better for you.",
    checkAdsLink: "View Listings"
  };
  
  const rus = {
    mainText: `ГУДС Израиль- это персональный маркетплейс, созданный для удобного, безопасного и простого размещения объявлений о продаже товаров.
  Проект был создан для того, чтобы сделать процесс покупки и продажи максимально комфортным как для частных лиц, так и для небольших продавцов в Израиле.`,
  
    ourGoalTitle: "Наша цель",
    ourGoalText: "Мы стремимся создать пространство, где каждый пользователь может легко:",
    goalList: [
      "Разместить объявление о продаже товара",
      "Найти нужную вещь по честной цене",
      "Быстро связаться с продавцом или покупателем",
      "Пользоваться платформой без лишних действий и сложностей"
    ],
  
    whyGoodsTitle: "Почему ГУДС?",
    cards: [
      {
        subtitle: "Удобство",
        text: "Интуитивно понятный интерфейс, простая форма добавления объявлений и продуманная структура каталога."
      },
      {
        subtitle: "Персональный подход",
        text: "ГУДС Израиль - это удобная платформа для вас. Мы делаем маркетплейс, в котором каждому пользователю удобно управлять своими объявлениями, профилем и общением."
      },
      {
        subtitle: "Безопасность и прозрачность",
        text: "Мы внимательно относимся к защите данных. Все персональные данные обрабатываются в соответствии с законодательством Израиля, а серверы находятся в регионе Франкфурт, что обеспечивает стабильность и высокий уровень безопасности."
      },
      {
        subtitle: "Быстрая модерация",
        text: "Мы стремимся к тому, чтобы на платформе размещались только честные предложения. Объявления проходят быструю проверку и модерацию."
      }
    ],
  
    forWhomTitle: "Для кого создан проект?",
    forWhomText: "Goods подходит всем, кто хочет:",
    forWhomList: [
      "Продать личные вещи",
      "Купить что-то выгодно",
      "Разместить товары своего небольшого бизнеса",
      "Вести продажи без сложных настроек и технических знаний"
    ],
  
    contactTitle: "Связь с проектом",
    contactText: "Если у вас есть вопросы или предложения - мы всегда открыты для обратной связи. Мы стремимся развивать платформу и делать её лучше для вас.",
    checkAdsLink: "Посмотреть объявления"
  };
  
  const hebrew = {
    mainText: `GOODS ישראל הוא שוק אישי שנוצר לנוחות, ביטחון ופשטות בפרסום פריטים למכירה.
  הפרויקט נוצר כדי להפוך את תהליך הקנייה והמכירה לנוח ככל האפשר עבור אנשים פרטיים ומוכרים קטנים בישראל.`,
  
    ourGoalTitle: "המטרה שלנו",
    ourGoalText: "אנו שואפים ליצור מקום שבו כל משתמש יכול בקלות:",
    goalList: [
      "לפרסם פריט למכירה",
      "למצוא את הפריט המתאים במחיר הוגן",
      "ליצור קשר מהיר עם המוכר או הקונה",
      "להשתמש בפלטפורמה ללא צעדים או סיבוכים מיותרים"
    ],
  
    whyGoodsTitle: "למה GOODS?",
    cards: [
      {
        subtitle: "נוחות",
        text: "ממשק אינטואיטיבי, טופס פרסום פשוט ומבנה קטלוג מתוכנן היטב."
      },
      {
        subtitle: "גישה אישית",
        text: "GOODS ישראל היא פלטפורמה נוחה בשבילכם. אנו יוצרים שוק שבו כל משתמש יכול לנהל בקלות את הפרסומים, הפרופיל והתקשורת שלו."
      },
      {
        subtitle: "בטיחות ושקיפות",
        text: "אנו מקפידים על הגנת המידע. כל המידע האישי מעובד בהתאם לחוקי ישראל, והשרתים ממוקמים בפרנקפורט, מה שמבטיח יציבות ורמת ביטחון גבוהה."
      },
      {
        subtitle: "מודרציה מהירה",
        text: "אנו דואגים שרק הצעות אמינות יפורסמו. הפרסומים עוברים בדיקה ומודרציה מהירה."
      }
    ],
  
    forWhomTitle: "למי הפרויקט מיועד?",
    forWhomText: "GOODS מתאים לכל מי שרוצה:",
    forWhomList: [
      "למכור פריטים אישיים",
      "לקנות משהו במחיר טוב",
      "לפרסם מוצרים מהעסק הקטן שלהם",
      "לנהל מכירות ללא הגדרות מסובכות או ידע טכני"
    ],
  
    contactTitle: "צור קשר",
    contactText: "אם יש לכם שאלות או הצעות - אנו תמיד פתוחים למשוב. אנו שואפים לפתח את הפלטפורמה ולעשות אותה טובה יותר עבורכם.",
    checkAdsLink: "צפה במודעות"
  };
  
  const choose = { en, rus, hebrew };
  export default choose;